import { type ReactElement, useState } from 'react';
import { Button } from '@/shared/ui';
import { HideReviewModal } from './hide-review-modal';

interface HideReviewDialogProps {
  readonly review: { readonly id: string; readonly updatedAt: string };
}

/** "숨기기" 버튼과 사유 입력 모달 — 모달은 열려 있을 때만 그린다. */
export const HideReviewDialog = ({ review }: HideReviewDialogProps): ReactElement => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" onClick={() => setOpen(true)}>
        숨기기
      </Button>
      {open ? <HideReviewModal review={review} onClose={() => setOpen(false)} /> : null}
    </>
  );
};
